// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1HeFK","axisTick":"styles_axisTick__1XrQy"};